/**
 * This constant was added in the latest version of the cms util packages in v1.x and forgotten to
 * add in v2.x of the package. This fix should not be merged, but a new version of the npm package should
 * include the new constant.
 */
export const LS_LOCK_DIALOG_ERROR_DOCUMENT_CHANGED = 'LS_LOCK_DIALOG_ERROR_DOCUMENT_CHANGED';
